import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['panel', 'overlay']

  open() {
    this.enableTransitions()
    this.panelTarget.classList.remove('translate-x-full')
    this.overlayTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    this.markAllRead()
  }

  close() {
    this.panelTarget.classList.add('translate-x-full')
    this.overlayTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }

  async markAllRead() {
    await post('/user_activities/mark_all_read')

    // Remove unread dots after a delay so the user can see them
    setTimeout(() => {
      this.panelTarget.querySelectorAll('[data-unread-dot]').forEach(dot => {
        dot.style.transition = 'opacity 0.3s ease-out'
        dot.style.opacity = '0'
        setTimeout(() => dot.remove(), 300)
      })
    }, 5000)

    // Clear the sidebar badge
    const badge = document.getElementById('feed_badge')
    if (badge) badge.innerHTML = ''

    // Clear the avatar notification badge
    const avatarBadge = document.getElementById('feed_avatar_badge')
    if (avatarBadge) avatarBadge.innerHTML = ''

    // Update the panel title (remove count)
    const title = this.panelTarget.querySelector('h2')
    if (title) {
      title.textContent = title.textContent.replace(/\s*\(\d+\)/, '')
    }
  }

  enableTransitions() {
    if (this.transitionsEnabled) return
    this.panelTarget.classList.add('transition-transform', 'duration-300', 'ease-in-out')
    this.overlayTarget.classList.add('transition-opacity')
    this.transitionsEnabled = true
  }
}
